import { render, staticRenderFns } from "./AddPackageTypeModal.vue?vue&type=template&id=494ec468"
import script from "./AddPackageTypeModal.vue?vue&type=script&lang=js"
export * from "./AddPackageTypeModal.vue?vue&type=script&lang=js"
import style0 from "./AddPackageTypeModal.vue?vue&type=style&index=0&id=494ec468&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports